var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / nutrition@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Awards-&-Illustrations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-nutrition"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "award---sorounding-icon",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    rx: 8
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.6703569,29.3069449 C11.890119,27.8691931 10,25.5137435 10,22.240596 C10,17.9940625 12.1658013,17.5181782 14.4028919,13.8370957 C15.0464706,12.7781014 15.806822,10.4990695 16.6839463,7 C22.7177736,11.0461791 26.0189232,15.0454872 26.5873951,18.9979244 C27.155867,22.9503617 25.5819088,26.2649532 21.8655206,28.9416991 C23.2603486,25.4174757 23.6891603,22.6638107 23.1519558,20.6807041 C22.6147513,18.6975975 21.1094869,16.8540223 18.6361626,15.1499786 C17.8290533,17.2654892 17.1345115,18.7086761 16.5525374,19.4795393 C15.0855713,21.4226328 13.7816103,23.0140798 13.5518119,24.1109989 C13.1732831,25.9178666 13.8794648,27.6498486 15.6703569,29.3069449 Z",
    id: "Path-3",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/Energy.63a8533639be63a70413e8a5d2c90387.svg";
export { ForwardRef as ReactComponent };